import { createBehavior } from '@area17/a17-behaviors';
import Swiper, { Navigation, EffectFade, Controller } from 'swiper';

import 'swiper/css';

const slideshow = createBehavior(
  'slideshow',
  {
    prev() {
      this.currentIndex = (this.currentIndex - 1) % this.items.length;
      this.render();
    },
    next() {
      this.currentIndex = (this.currentIndex + 1) % this.items.length;
      this.render();
    },
    render() {
      this.$index.innerHTML = (this.currentIndex + 1)
        .toString()
        .padStart(2, '0');
    },
  },
  {
    init() {
      this.currentIndex = 0;

      // Swipers
      this.$text = this.getChild('text');
      this.$image = this.getChild('image');

      if (this.$text) {
        this.textSwiper = new Swiper(this.$text, {
          modules: [EffectFade],
          effect: 'fade',
          speed: 300,
          autoHeight: true,
          fadeEffect: {
            crossFade: true,
          },
          loop: true,
          allowTouchMove: false,
        });
      }

      if (this.$image) {
        this.imageSwiper = new Swiper(this.$image, {
          modules: [Controller, Navigation],
          direction: 'horizontal',
          loop: true,
          grabCursor: true,
          initialSlide: 0,
          navigation: {
            nextEl: this.getChild('next-btn'),
            prevEl: this.getChild('prev-btn'),
          },
        });

        if (this.textSwiper) {
          this.imageSwiper.controller.control = this.textSwiper;
        }

        this.imageSwiper.on('slideChange', (swiper) => {
          this.getChild('index').innerText = (swiper.realIndex + 1)
            .toString()
            .padStart(2, '0');
        });
      }

      // Slideshow control
      this.$index = this.getChild('index');
      this.$total = this.getChild('total');
      this.$prevBtn = this.getChild('prev-btn');
      this.$nextBtn = this.getChild('next-btn');
      if (this.$prevBtn){
        this.$prevBtn.addEventListener('click', this.onPrevBtnClick);
      }
      if (this.$nextBtn){
        this.$nextBtn.addEventListener('click', this.onNextBtnClick);
      }
      
    },
    destroy() {},
  }
);

export default slideshow;
